export const childState = {
  id: null,
  metadataIds: [],
  total: 0,
  status: {
    draft: {
      total: 0,
    },
    new: {
      total: 0,
    },
  },
};

export const initialState = {
  fetchData: false,
  0: childState,
};
